<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import { RouterView } from 'vue-router';



export default {
  name: 'app',
}
</script>
<style>
body{
  min-width:800px;
  background:#012430;
}
::-webkit-scrollbar {
   width: 0;
}
::-webkit-scrollbar {
 width: 0 ;height: 0;
}
.limited-input {
  width: 400px !important; /* 设置为您想要的长度 */
}
.limited-input300 {
  width: 300px !important;
  /* 设置为您想要的长度 */
}
.limited-input360 {
  width: 360px !important;
  /* 设置为您想要的长度 */
}
.limited-input120 {
  width: 120px !important;
  /* 设置为您想要的长度 */
}
.limited-input150 {
  width: 150px !important;
  /* 设置为您想要的长度 */
}
.limited-input260 {
  width: 260px !important;
  /* 设置为您想要的长度 */
}
.ml-10{
  margin-left: 10px !important;
}
.mb-30{
  margin-bottom: 30px;
}
/* 隐藏浏览器自带的滚动条 */
body::-webkit-scrollbar {
  width: 0;
  /* 调整滚动条宽度 */
}

body::-webkit-scrollbar-track {
  background-color: transparent;
  /* 设置滚动条轨道背景色为透明 */
}

body::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  /* 设置滚动条滑块颜色 */
  border-radius: 0.25em;
  /* 设置滚动条滑块圆角 */
}

/* 显示页面内的滚动条 */
.scrollable-content {
  overflow-y: auto;
  /* 启用垂直滚动条 */
}
/deep/.el-tag--medium{
  font-size: 35px;
  height: 50px;
  line-height: 50px;
}
.tabOperate{
    background-color: #fff;
    margin: 0 20px;
    padding: 8px 16px;
    font-size: 32px;
    font-weight: 600;
    border-radius: 5px;
    color: #fff;
}
.tabactive{
  background-color: #00BAAD !important;
}
.tab{
    display: flex;
    align-items: center;
    background-color: #fff;
    margin: 0 20px;
    padding: 8px 16px;
    font-size: 20px;
    font-weight: 600;
    border-radius: 10px;
}
.table-title{
    text-align: center;
    width:20%;
    color: #fff;
    border: 1px solid #000;
    padding: 10px 0;
    font-size: 25px;
    font-weight: 600;
}
.text-stroke {
  text-shadow: 
    -2px -2px 1px #000,  
    2px -2px 1px #000,
    -2px  2px 1px #000,
    2px  2px 1px #000;
}
.table-item{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width:20%;
    border: 1px solid #000;
    padding: 10px 0;
    font-size: 20px;
    font-weight: 600;
}
#scrollable-area {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 10%; /* 根据需要设置 */
}
</style>